import { Facility } from 'apps/marketplace/apiTypes/facilities'
import { ShipperFacility } from 'apps/marketplace/apiTypes/shipperFacilities'
import { TFacilityOverviewSchema } from '../components/FacilityOverview/FacilityOverviewFormSchema'

/**
 * Get a facility and return overview data suitable for display
 * @param facility A facility
 * @returns Overview data ready for display if undefined, null properly set to defaults
 */
export const getFacilityOverview = (facility?: Facility): TFacilityOverviewSchema => {
  const { facilityType = '', isHighRisk = false, location, name = '', numberOfDocks = null } =
    facility || {}

  const {
    address = '',
    addressLine2 = null,
    city = '',
    countryCode = 'US',
    stateCode = '',
    zipcode = '',
  } = location || {}

  return {
    location: {
      address,
      addressLine2,
      city,
      stateCode,
      countryCode,
      zipcode,
    },
    numberOfDocks,
    name,
    facilityType,
    facilityCode: '',
    facilityCodes: [],
    ediLocationCode: '',
    ediLocationCodes: [],
    isHighRisk,
  }
}

export const getShipperFacilityOverview = (
  shipperFacility: ShipperFacility | undefined
): TFacilityOverviewSchema => {
  const {
    ediLocationCode = '',
    ediLocationCodes = [],
    facilityCode = '',
    facilityCodes = [],
    facilityType = '',
    location,
    numberOfDocks = null,
    isHighRisk = false,
    shipperApplicationName = '',
  } = shipperFacility || {}

  const {
    address = '',
    addressLine2 = { value: null, overridden: false },
    city = '',
    countryCode = 'US',
    stateCode = '',
    zipcode = '',
  } = location || {}

  return {
    location: {
      address,
      addressLine2: addressLine2.value,
      city,
      stateCode,
      countryCode,
      zipcode,
    },

    numberOfDocks,
    isHighRisk,
    name: shipperApplicationName,
    facilityType,
    facilityCode: facilityCode || '',
    facilityCodes: facilityCodes || [],
    ediLocationCode: ediLocationCode || '',
    ediLocationCodes: ediLocationCodes || [],
  }
}
